import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "Component", "formControlUse"],
  _excluded2 = ["hideEditIcon", "isStatic", "label", "overlayContent"],
  _excluded3 = ["hideEditIcon", "isStatic", "label"];
import UIFloatingFormControl from 'UIComponents/form/UIFloatingFormControl';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import { usePropertyDefinition } from '../hooks/usePropertyDefinition';
import { useGetIsUngated } from '../hooks/useGetIsUngated';
import styled from 'styled-components';
import { isFile } from 'customer-data-objects/property/PropertyIdentifier';
import { FILE_TYPE_ENHANCED_UX_GATE } from '../../files/constants';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const getLabel = propertyDefinition => {
  return propertyDefinition.hubspotDefined ? propertyLabelTranslator(propertyDefinition.label) : propertyDefinition.label;
};
const StyledDivOverlayWrapper = styled.div.withConfig({
  displayName: "FormControl__StyledDivOverlayWrapper",
  componentId: "sc-11dl6z1-0"
})(["height:100%;"]);

// eslint-disable-next-line hubspot-dev/no-private-classes
const StyledUIFloatingFormControl = styled(UIFloatingFormControl).withConfig({
  displayName: "FormControl__StyledUIFloatingFormControl",
  componentId: "sc-11dl6z1-1"
})([".private-form__control__overlay{background:transparent !important;box-shadow:none !important;}"]);
const FormControl = _ref => {
  let {
      children,
      Component = UIFormControl,
      formControlUse = 'default'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const propertyDefinition = usePropertyDefinition();
  const getIsUngated = useGetIsUngated();
  if (formControlUse === 'inline' || formControlUse === 'table-cell' || !Component) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  const hasLabelGate = getIsUngated('CRM:Properties:DefaultLabel');
  const hasFilePropertyGate = getIsUngated(FILE_TYPE_ENHANCED_UX_GATE);
  const defaultLabel = hasLabelGate ? getLabel(propertyDefinition) : undefined;
  const isFileProperty = hasFilePropertyGate ? isFile(propertyDefinition) : false;
  if (formControlUse === 'floating' || Component === UIFloatingFormControl) {
    const {
        hideEditIcon,
        isStatic,
        label = defaultLabel,
        overlayContent
      } = rest,
      other = _objectWithoutPropertiesLoose(rest, _excluded2);
    const overlayContentWithWrapper = isFileProperty ? /*#__PURE__*/_jsx(StyledDivOverlayWrapper, {
      children: overlayContent
    }) : overlayContent;
    return /*#__PURE__*/_jsx(StyledUIFloatingFormControl, Object.assign({
      hideEditIcon: hideEditIcon,
      isStatic: isStatic,
      "data-test-id": UIFloatingFormControl.name,
      label: label,
      overlayContent: overlayContentWithWrapper
    }, other, {
      children: children
    }));
  }
  const {
      label = defaultLabel
    } = rest,
    other = _objectWithoutPropertiesLoose(rest, _excluded3);
  return /*#__PURE__*/_jsx(Component, Object.assign({
    "data-test-id": Component.name,
    label: label
  }, other, {
    children: children
  }));
};
export default FormControl;